import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsLuaComponent } from './simple-icons-lua.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsLuaComponent ],
    exports:      [ SimpleIconsLuaComponent ],
    bootstrap:    []
})
export class SimpleIconsLuaModule {}
